<template>
  <index msg="Welcome to Your Vue.js App"/>
</template>

<script>
import index from './components/index.vue'

export default {
  name: 'App',
  components: {
    index
  }
}
</script>

<style>

</style>
